import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { Specification } from '../model/Specification';

@Injectable()
export class EspecificationService {
  url:string = GLOBAL.url+"specifications";

  constructor( private http:HttpClient ) {}
/**
 * Obtiene el listado de todas las especificaciones.
 * @return listado de especificaciones o un error.
 */
  public get(){
    return this.http.get(this.url ).map( res => {
        return res;
    });
  }

  public getDataFiltered(filters){
    let url = this.url+filters;
    return this.http.get(url).map( res => {
        return res;
    });
  }

  public getAll(){
    //let url = this.url+'&limit=100';
    let url = this.url+'?limit=100';
    return this.http.get(url ).map( res => {
        return res;
    });
  }

/**
 * Envia un POST para almacenar información.
 * @param  prov información a enviar
 * @return      respuesta de la peticion http
 */
  public save(prov:any){

    return this.http.post(this.url, prov)
      .map( data => {
        return data;
      });
  }

/**
 * Actualiza un elemento en la base de datos
 * @param  url  url del elemento que se actualiza.
 * @param  body ¿?
 * @return      respuesta de la peticion http
 */
  public update(url:string, body){

    return this.http.put(url, body)
      .map( data => {return data;});
  }

/**
 * Elimina un registro de la base de datos
 * @param  url url del elemento que se elimina
 * @return     respuesta de la peticion http
 */
  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });

  }

/**
 * Transforma una fecha (YYYY-MM-DD 00:00:00) para ser almacenada en una BD.
 * @param  fechas fecha a transformar
 * @return        fecha con el formato (YYYY-MM-DD 00:00:00)
 */
 transformDates(fechas:Date):String{
   let fecha = moment(fechas);
   //2018-02-28 00:00:00
   return (fecha.year()+'-'+(fecha.month()+1)+'-'+fecha.date()+' 00:00:00');
 }

/**
 * Transforma un objeto a un formato JSON predefinido en el modelo.
 * @param  data Informacion a transformar.
 * @return      Objeto con el formato JSON correcto.
 */
  transformData(data:any){
    let p = new Specification(
      data['id'],
      data['codigo']
    );
    return p.getJson();
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/especification.service.ts